import { render } from "./QuickReservation.vue?vue&type=template&id=931dde0c&scoped=true&ts=true"
import script from "./QuickReservation.vue?vue&type=script&lang=ts"
export * from "./QuickReservation.vue?vue&type=script&lang=ts"

import "./QuickReservation.vue?vue&type=style&index=0&id=931dde0c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-931dde0c"]])

export default __exports__